<template>
    <div>
        <Pane title="重新提交设计计划修订单" :showRemarks="false">
            <template>重新发起设计计划修订单流程</template>
        </Pane>

        <div class="container">
            <a-skeleton :loading="loading" :paragraph="{ rows: 8 }">
                <a-form :model="form" layout="horizontal" :colon="false" label-align="right"
                        :label-col="{ span: 6 }"
                        :wrapper-col="{ span: 16 }">
                    <a-row :gutter="16">
                        <a-col :span="12">
                            <a-form-item label="序列号">
                                <a-input v-model="form.serialNo" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12" />

                        <a-col :span="12">
                            <a-form-item label="设计编号">
                                <a-input v-model="form.designNo" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="工程名称">
                                <a-input v-model="form.projectName" disabled />
                            </a-form-item>
                        </a-col>
                        <a-col :span="12">
                            <a-form-item label="管理级别">
                                <a-radio-group v-model="form.manageLevel" disabled>
                                    <a-radio-button
                                        v-for="item in manageLevelList"
                                        :key="item.value"
                                        :value="item.value"
                                    >{{ item.name }}</a-radio-button>
                                </a-radio-group>
                            </a-form-item>
                        </a-col>

                        <a-col :span="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="修改原因">
                                <a-textarea v-model="form.reviseReason" :rows="4" placeholder="请输入修改原因" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="修改内容">
                                <a-textarea v-model="form.reviseContent" :rows="6" placeholder="请输入修改内容" />
                            </a-form-item>
                        </a-col>

                        <a-col :span="24">
                            <a-form-item :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" label="附件">
                                <Attachment :editable="true" :fileList="fileList" @change="handleFileListChange" />
                            </a-form-item>
                        </a-col>
                    </a-row>

                    <div class="center">
                        <a-space>
                            <a-button type="primary" @click="submitReview" :loading="submitting">
                                重新提交
                            </a-button>
                            <a-button @click="goBack">返回</a-button>
                        </a-space>
                    </div>
                </a-form>
            </a-skeleton>
        </div>
    </div>
</template>

<script>
import { fetchDesignPlanReviseDetail, resubmitDesignPlanRevise } from "@/api/project-plan/revise";
import { mapMutations, mapGetters, mapState } from "vuex";
import Attachment from "@/components/attachment";
import { parseAttachment, buildAttachmentData } from '@/utils/attachment'

export default {
    name: "DesignPlanReviseReapply",
    components: { Attachment },
    data() {
        return {
            loading: false,
            submitting: false,
            id: "",
            taskId: "",
            instanceId: "",
            fileList: [],
            form: {
                serialNo: "",
                designNo: "",
                projectName: "",
                phaseCode: "",
                manageLevel: "",
                reviseReason: "",
                reviseContent: "",
                attachment: "",
                attachmentPaths: "",
            },
        };
    },
    computed: {
        ...mapState("approval", ["detail"]),
        ...mapGetters("setting", ["findDataDict"]),
        manageLevelList() {
            return this.findDataDict("cosys.manageLevel") || [];
        },
        designPhaseList() {
            return this.findDataDict("cosys.designPhase") || [];
        },
    },
    mounted() {
        const { taskId, instanceId } = this.$route.query;
        this.taskId = taskId || "";
        this.instanceId = instanceId || "";

        const routeId = this.$route.params.id;
        if (routeId) {
            this.id = routeId;
        } else {
            const { businessKey } = this.$route.query;
            if (businessKey) {
                const parts = businessKey.split(":");
                this.id = parts.length > 1 ? parts[1] : "";
            }
        }

        if (this.id) {
            this.fetchDetail(this.id);
        }
        if (this.taskId && this.instanceId) {
            this.setTaskId(this.taskId);
            this.setInstanceId(this.instanceId);
        }
    },
    methods: {
        ...mapMutations("approval", ["setTaskId", "setInstanceId"]),
        fetchDetail(id) {
            this.loading = true;
            fetchDesignPlanReviseDetail(id)
                .then((res) => {
                    const data = res || {};
                    this.form.serialNo = data.serialNo || "";
                    this.form.designNo = data.designNo || "";
                    this.form.projectName = data.projectName || "";
                    this.form.phaseCode = data.phaseCode || "";
                    this.form.manageLevel = data.manageLevel || "";
                    this.form.reviseReason = data.reviseReason || "";
                    this.form.reviseContent = data.reviseContent || "";
                    this.form.attachment = data.attachment || "";
                    this.form.attachmentPaths = data.attachmentPaths || "";

                    this.syncFileListFromAttachment();

                    this.loading = false;
                })
                .catch(() => {
                    this.$message.error("获取设计计划修订单详情失败");
                    this.loading = false;
                });
        },
        syncFileListFromAttachment() {
            this.fileList = parseAttachment(this.form.attachment, this.form.attachmentPaths);
        },
        updateAttachment() {
            const { attachment, attachmentPaths } = buildAttachmentData(this.fileList);
            this.form.attachment = attachment;
            this.form.attachmentPaths = attachmentPaths;
        },
        handleFileListChange(list) {
            this.fileList = list;
            this.updateAttachment();
        },
        submitReview() {
            this.submitting = true;
            this.updateAttachment();
            resubmitDesignPlanRevise({
                id: this.id,
                reviseReason: this.form.reviseReason,
                reviseContent: this.form.reviseContent,
                attachment: this.form.attachment,
                attachmentPaths: this.form.attachmentPaths,
            })
                .then(() => {
                    this.$close(this.$route.path, "/approval/task");
                })
                .catch((e) => {
                    console.error("提交失败详情", e);
                    this.$message.error("提交失败");
                })
                .finally(() => {
                    this.submitting = false;
                });
        },
        goBack() {
            this.$close(this.$route.path);
        },
    },
};
</script>

<style lang="less" scoped>
.container {
    background-color: #fff;
    padding: 24px 160px;
}

.center {
    margin-top: 80px;
    display: flex;
    justify-content: center;
}
</style>
